/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Коллекция для организаторов совместных покупок
   */
  app.JPOrganizersPageable = app.ItemPageableCollection.extend({
    
    model: app.Model,
    apiUrl: '/api/v3/jp-organizer/',
    fetchOptions: {},
    
    url: function () {
      return app.entryScriptName + this.apiUrl;
    },
    isScroll: false,
    loadItems: true,
    loadFilters: false,
    requestFilters: false,
    filterLoadParams: [],
    itemsNotLoadParams: [],
    sortTypes: [],
    state: {
      firstPage: 1,
      pageSize: 20,
      order: 0
    },
    
    initialize: function (models, options) {
      if (options && options.defaults && _.isObject(options.defaults)) {
        _.extend(this.defaults, options.defaults);
      }
      Backbone.PageableCollection.prototype.initialize.apply(this, arguments);
      this.setQueryParams();
      
      if (options && options.apiUrl) {
        this.apiUrl = options.apiUrl;
      }
      if (options && options.settlementForm) {
        this.settlementForm = options.settlementForm;
        /**
         * После первого фетча settlementForm подписываемся на sync,
         * чтобы запрашивать список организаторов после смены города/района
         */
        this.listenToOnce(this.settlementForm, 'sync', function () {
          this.listenTo(this.settlementForm, 'sync', this.updateUrlAndFetch);
        });
      }
      if (options && options.fetchOptions) {
        this.fetchOptions = options.fetchOptions;
      }
      
      this.listenTo(this, 'sync', this.checkCollection);
      
      // устанавливаем дефолтные свойства
      this.setDefaultProperties();
    },
    /**
     * Проверяем коллекцию, запрашиваем данные по всему городу, если по району нет организаторов.
     * Если пришел список организаторов, триггерим событие готовности коллеции
     * @param collection
     * @param response
     * @param options
     */
    checkCollection: function (collection, response, options) {
      // Если пришел пустой массив и запрашивали район, пробуем запросить без района
      if (!collection.length && options && options.data && options.data.district_id) {
        this.state.currentPage = 1;
        this.updateUrlAndFetch({
          isForcedWholeCity: true
        });
      } else {
        this.trigger('collection:ready', this.models, options);
      }
    },
    /**
     * Убираем district из параметров запроса, если в опциях isForcedWholeCity=true,
     * и запрашиваем первую страницу
     * @param options
     */
    updateUrlAndFetch: function (options) {
      if (!options || !options.isForcedWholeCity) {
        options = null;
      }
      
      this.setQueryParams(options);
      
      this.getFirstPage({
        fetch: true,
        isForcedWholeCity: (options && options.isForcedWholeCity) ? options.isForcedWholeCity : false
      });
    },
    
    /**
     * Установка параметров запроса
     * @param options
     */
    setQueryParams: function (options) {
      var that = this,
        userDistrictId = !this.fetchCounter ? app.user.get('district_id') : null;
      this.queryParams = {
        totalRecords: function () {
          return that.totalPages;
        },
        currentPage: 'page',
        pageSize: 'per-page',
        sort: function () {
          return that.sort;
        },
        totalPages: 'page_count',
        expand: 'jp_contacts,'
                + 'jp_payment,'
                + 'jp_prepayment,'
                + 'jp_payments,'
                + 'jp_prepayments,'
                + 'jp_purchase,'
                + 'jp_address_delivery,'
                + 'jp_pickup_delivery,'
                + 'jp_payment_type',
        settlement_id: function () {
          return that.settlementForm.get('settlement_id');
        },
        district_id: function () {
          var districtId = this.settlementForm.get('district_id') || userDistrictId;
          // Убираем district из параметров запроса, если в опциях isForcedWholeCity=true
          if (options && options.isForcedWholeCity) {
            return null;
          }
          return districtId;
        },
        min_request_sum: function () {
          return app.cartSum;
        }
      };
    },
    /**
     * Устанавливает дефолтные свойства коллекции
     */
    setDefaultProperties: function () {
      this.sort = this.defaults.sort;
    }
    
  });
})();

}.call(window));